import { validationIsEqual } from '../status';
import { validateBase64File } from '@om/validation';
import {
    BIRTH_CERTIFICATE_SET_VALUE,
    ID_UPLOAD_SET_VALUE,
    KRA_PIN_UPLOAD_SET_VALUE,
    setBirthCertificateUploadValid,
    setBirthCertificateUploadValue,
    setIdUploadValid,
    setKraPinUploadValid,
    setSpouseIdDocUploadValid,
    SPOUSE_ID_SET_VALUE,
} from '../../../actions/afyaImara/Documents';

let prevValidationAction = null;
export const documentsUploadValidation = (store, next, action) => {
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case ID_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value?.base64File, {
                    subject: 'ID',
                    required: true,
                });
                return setIdUploadValid(error);

            case KRA_PIN_UPLOAD_SET_VALUE:
                error = validateBase64File(action.value?.base64File, {
                    subject: 'KRA PIN Certificate',
                    required: true,
                });
                return setKraPinUploadValid(error);

            case SPOUSE_ID_SET_VALUE:
                error = validateBase64File(action.value?.base64File, {
                    subject: 'SPOUSE ID',
                    required: true,
                });
                return setSpouseIdDocUploadValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
